<script lang="ts">
  import { fly } from "svelte/transition"
  import { xhr } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import Button from "$app/components/ButtonSpinner.svelte"
  import Content from "./Content.svelte"
  import { appStore } from "$app/store.svelte"

  interface Props {
    course_progress: CourseProgressType
    onUpdateProgress: (course_progress: CourseProgressType) => void
    purchaseCourse: () => void
  }
  let {
    course_progress = $bindable(),
    onUpdateProgress,
    purchaseCourse
  }: Props = $props()

  let show_assets = $state(false)

  import pdf_download from "@images/courses/pdf-download.png"
  import pdf_download_hover from "@images/courses/pdf-download-hover.png"
  import download_assets from "@images/courses/download-assets.png"
  import close_assets from "@images/courses/close-assets.png"

  let savingProgress = $state(false)
  async function saveProgress(): Promise<void> {
    savingProgress = true

    try {
      const resp = await xhr.patch(
        `/plans/${appStore.plan.id}/courses/e2/${appStore.course.id}.json`,
        {
          course_progress: {
            completed_step: course_progress.step,
            completed_substep: course_progress.substep
          }
        }
      )
      course_progress = resp.data
      onUpdateProgress(course_progress)
    } catch (e) {
      console.log(e)
      Honeybadger.notify(e)
    } finally {
      savingProgress = false
    }
  }
</script>

<div class="flex w-full">
  <div class="flex-grow py-12 px-12">
    {#if course_progress?.substep_data?.content === "video_embed"}
      <p class="text-center text-3xl text-bold">
        {course_progress.substep_data.title}
      </p>

      <div class="px-12 my-12 w-full">
        <div class="relative" style="padding-top: 56.25%">
          <iframe
            src="https://player.vimeo.com/video/{course_progress.substep_data
              .video_embed_id}"
            class="absolute inset-0 w-full h-full"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            title="E3 Course"
          ></iframe>
        </div>
      </div>
    {:else}
      <Content {course_progress} />
    {/if}

    <div class="text-center pb-8">
      {#if !course_progress?.purchased}
        <button
          class="btn big bg-green-600 hover:bg-green-700 text-white inline font-bold text-center"
          onclick={purchaseCourse}>Purchase Course & Unlock All Content</button
        >
      {:else if course_progress.step < 8 || (course_progress.step == 8 && course_progress.substep < 2) || (course_progress.completed_step == 8 && course_progress.completed_substep < 2)}
        <Button
          class="btn btn-rounded success btn-big"
          processing={savingProgress}
          onclick={() => {
            saveProgress()
          }}
        >
          COMPLETE & CONTINUE
        </Button>
      {/if}
    </div>
  </div>

  {#if show_assets && course_progress.assets.length > 0}
    <div
      class="absolute w-60 right-0 rounded-tl-lg rounded-bl-lg bg-green-50 shadow-lg border border-grey-500"
      style="top: 30%;"
      transition:fly={{ x: 250, opacity: 1 }}
    >
      <div
        class="flex flex-col justify-center h-full px-2 py-12 w-full relative"
      >
        <button
          onclick={() => (show_assets = !show_assets)}
          class="z-10 w-10 absolute"
          style="top: 8%; left: -2.5rem;"
          transition:fly={{ opacity: 0 }}
        >
          <img src={close_assets} alt="Close Assets" />
        </button>

        <p class="text-center text-3xl">Assets</p>
        {#each course_progress.assets as asset}
          <a
            href={asset.href}
            target="_blank"
            rel="noopener noreferrer"
            class="mt-6 flex flex-col justify-center"
          >
            <div class="relative w-24 mx-auto">
              <img
                src={pdf_download}
                alt="Download PDF"
                class="w-24 hover:opacity-0"
              />
              <img
                src={pdf_download_hover}
                alt="Download PDF"
                class="absolute top-0 w-24 opacity-0 hover:opacity-100"
              />
            </div>

            <span class="text-center px-6 mt-1">
              {asset.name}
            </span>
          </a>
        {/each}
      </div>
    </div>
  {:else if course_progress.assets.length > 0}
    <button
      class="grow z-10 w-12 absolute right-0"
      transition:fly={{ opacity: 0 }}
      onclick={() => (show_assets = !show_assets)}
    >
      <img src={download_assets} alt="Download Assets" />
    </button>
  {/if}
</div>

<style>
  .grow {
    top: 36%;
    transition: all 0.2s ease-in-out;
    animation: leaves 0.3s ease-in-out alternate;
    -webkit-animation: leaves 0.3s ease-in-out alternate;
    animation-iteration-count: 4;
  }
  .grow:hover {
    animation: leaves 0.4s ease-in-out infinite alternate;
    -webkit-animation: leaves 0.4s ease-in-out infinite alternate;
  }
  @keyframes leaves {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.2);
    }
  }
</style>
